// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfile .title {
  padding: 3%;
  border-bottom: rgba(0, 0, 0, 0.1) solid 1px;
}
.UserProfile .sideAndfields {
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
}
.UserProfile .sideAndfields .side {
  padding: 10% 5%;
  border-right: rgba(0, 0, 0, 0.1) solid 1px;
}
.UserProfile .sideAndfields .side > div {
  margin: 5% 0;
}
.UserProfile .fields {
  margin: 5% 0;
}
.UserProfile .fields .image {
  display: flex;
  margin-bottom: 5%;
}
.UserProfile .fields .image .circleButton {
  border: gray solid 1px;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  transition: all 0.3s ease;
}
.UserProfile .fields .image .circleButton:hover {
  cursor: pointer;
  transform: scale(1.1);
  background-color: unset;
}
.UserProfile .fields .image .circleButton .circleButton {
  border: unset;
}
.UserProfile .fields .image .buttonWithCaption {
  margin-left: 5%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.UserProfile .fields .image .buttonWithCaption .button {
  width: fit-content;
}
.UserProfile .fields .image .buttonWithCaption .caption {
  margin-top: 5%;
}
.UserProfile .fields .image .caption {
  display: flex;
  align-items: center;
  text-align: left;
}
.UserProfile .fields .metadata {
  display: grid;
  grid-row-gap: 15px;
}
.UserProfile .firstLastName {
  display: grid;
  grid-template-columns: 0.5fr 0.5fr;
  gap: 15px;
}
.UserProfile .submit {
  text-align: right;
  margin-top: 5%;
}`, "",{"version":3,"sources":["webpack://./src/views/UserProfile/style.scss"],"names":[],"mappings":"AAGE;EACE,WAAA;EACA,2CAAA;AAFJ;AAKE;EACE,aAAA;EACA,kCAAA;AAHJ;AAII;EACE,eAAA;EAIA,0CAAA;AALN;AAEM;EACE,YAAA;AAAR;AAKE;EACE,YAAA;AAHJ;AAII;EACE,aAAA;EACA,iBAAA;AAFN;AAGM;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AADR;AAEQ;EACE,eAAA;EACA,qBAAA;EACA,uBAAA;AAAV;AAEQ;EACE,aAAA;AAAV;AAGM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADR;AAEQ;EACE,kBAAA;AAAV;AAEQ;EACE,cAAA;AAAV;AAGM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAII;EACE,aAAA;EACA,kBAAA;AAFN;AAME;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AAJJ;AAOE;EACE,iBAAA;EACA,cAAA;AALJ","sourcesContent":["$borderColor: rgba(0, 0, 0, 0.1);\n\n.UserProfile {\n  .title {\n    padding: 3%;\n    border-bottom: $borderColor solid 1px;\n  }\n\n  .sideAndfields {\n    display: grid;\n    grid-template-columns: 0.3fr 0.7fr;\n    .side {\n      padding: 10% 5%;\n      & > div {\n        margin: 5% 0;\n      }\n      border-right: $borderColor solid 1px;\n    }\n  }\n  .fields {\n    margin: 5% 0;\n    .image {\n      display: flex;\n      margin-bottom: 5%;\n      .circleButton {\n        border: gray solid 1px;\n        border-radius: 50%;\n        width: 70px;\n        height: 70px;\n        transition: all 0.3s ease;\n        &:hover {\n          cursor: pointer;\n          transform: scale(1.1);\n          background-color: unset;\n        }\n        .circleButton {\n          border: unset;\n        }\n      }\n      .buttonWithCaption {\n        margin-left: 5%;\n        margin-top: 10px;\n        display: flex;\n        flex-direction: column;\n        .button {\n          width: fit-content;\n        }\n        .caption {\n          margin-top: 5%;\n        }\n      }\n      .caption {\n        display: flex;\n        align-items: center;\n        text-align: left;\n      }\n    }\n    .metadata {\n      display: grid;\n      grid-row-gap: 15px;\n    }\n  }\n\n  .firstLastName {\n    display: grid;\n    grid-template-columns: 0.5fr 0.5fr;\n    gap: 15px;\n  }\n\n  .submit {\n    text-align: right;\n    margin-top: 5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
